import { createTidalTheme } from '@workwave-tidal/core/styles'

export const tidalTheme = createTidalTheme({
  colorSchemes: {
    light: {
      palette: {
        background: {
          default: '#F9FAFB',
        },
      },
    },
  },
  typography: {
    fontFamily: 'Roboto',
    body1: { fontFamily: 'Roboto' },
    body2: { fontFamily: 'Roboto' },
    button: { fontFamily: 'Roboto', textTransform: 'none' },
    caption: { fontFamily: 'Roboto' },
    h1: { fontFamily: 'Roboto' },
    h2: { fontFamily: 'Roboto' },
    h3: { fontFamily: 'Roboto' },
    h4: { fontFamily: 'Roboto' },
    h5: { fontFamily: 'Roboto' },
    h6: { fontFamily: 'Roboto' },
    h7: { fontFamily: 'Roboto' },
    subtitle1: { fontFamily: 'Roboto' },
    subtitle2: { fontFamily: 'Roboto' },
    subtitle3: { fontFamily: 'Roboto' },
    subtitle4: { fontFamily: 'Roboto' },
  },
})
